import { apportionmentTaxes } from './taxes/index';
import { apprMiscMtg } from './miscMtg/index';
import { apportionmentTab } from './apportionmnetTab/index';
import { apportionmentRemitWarrants } from './warrants/index';
import { axAppropriationsUtils } from './approprations/approprations';

export const apportionment = {
  namespaced: true,
  modules: {
    apportionmentTaxes,
    apprMiscMtg,
    apportionmentTab,
    apportionmentRemitWarrants,
    axAppropriationsUtils,
  },
};

export default apportionment;
